import {
  PORTAL_MODAL_FEATURE_GATOR_PROTECT,
  PORTAL_MODAL_SITE_WITHOUT_PROTECTION_ID,
  PORTAL_MODAL_SITE_WITHOUT_PROTECTION_NO_THREATS_ID,
} from './portalModals.constants';

/**
 * @param {{ modals?: unknown[] }} responseLike
 * @returns {import('./portalModals.types').GatorProtectThreatModalData | null}
 */
export function pickGatorProtectSiteWithoutProtectionData(responseLike) {
  const modals = Array.isArray(responseLike?.modals) ? responseLike.modals : [];
  const item = modals.find(
    m => m?.modal_id === PORTAL_MODAL_SITE_WITHOUT_PROTECTION_ID
      && m?.feature === PORTAL_MODAL_FEATURE_GATOR_PROTECT,
  );
  const data = item?.data;
  if (data == null || typeof data !== 'object') {
    return null;
  }
  return data;
}

/**
 * @param {{ modals?: unknown[] }} responseLike
 * @returns {import('./portalModals.types').GatorProtectThreatModalData | null}
 */
export function pickSiteWithoutProtectionNoThreatsData(responseLike) {
  const modals = Array.isArray(responseLike?.modals) ? responseLike.modals : [];
  const item = modals.find(
    m => m?.modal_id === PORTAL_MODAL_SITE_WITHOUT_PROTECTION_NO_THREATS_ID
      && m?.feature === PORTAL_MODAL_FEATURE_GATOR_PROTECT,
  );
  const data = item?.data;
  if (data == null || typeof data !== 'object') {
    return null;
  }
  const hostingId = data.hosting_id;
  if (hostingId == null || Number.isNaN(Number(hostingId))) {
    return null;
  }
  return data;
}
